import React from 'react';
import Model from '../../components/Model';

export default function Customizable() {
  return (
    <Model
      title={'Customizable AI Preview'}
      src={'/video/mobile/customizable-ai-preview.mp4'}
      para1={
        'The customizable chat preview is a way for users with cognitive disabilities to have Accessibee summarize their recent chat history with the selected contact. Or, they also have the option to simply view the last message similar to conventional messaging apps.'
      }
    />
  );
}
